import {externalHttpClient} from "./externalHttpClient";
import {httpClient} from "./httpClient";

export const clients = {
	externalHttpClient: externalHttpClient,
	httpClient: httpClient,
};
